import { cn } from 'cn';
import type { ComponentProps } from 'react';

export type IconProps = ComponentProps<'span'> & {
  name: string;
};

export const Icon = ({ className, name, ...props }: IconProps) => {
  return (
    <span className={cn(`iconify ${name}`, className)} role="img" {...props} />
  );
};
